import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const TableFrame = styled.div`
  width: 100%;
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
  overflow: hidden;
`;

export const TableColumns = styled.div`
  display: flex;
  width: 100%;
`;

export const HalfColumn = styled.div`
  flex: 0 0 50%;  
  min-width: 0;
`;

export const FlexColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

/** Equal-width columns (e.g. Activity V# / dates / author — thirds of the row). */
export const EqualColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;

/** Narrow column for TYPE badges (~60px in Figma). */
export const NarrowColumn = styled.div`
  flex: 0 0 60px;
  min-width: 0;
`;

export const HeaderCell = styled.div<{ $contentAlign?: "start" | "center" }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $contentAlign }) =>
    $contentAlign === "center" ? "center" : "flex-start"};
  text-align: ${({ $contentAlign }) =>
    $contentAlign === "center" ? "center" : "start"};
  min-height: 40px;
  padding: ${spacing[3]} ${spacing[2]};
  background-color: ${rawColors.structural[100]};
  border-bottom: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  ${typographyMixin("overline", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const BodyCell = styled.div<{
  $isLast?: boolean;
  $contentAlign?: "start" | "center";
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ $contentAlign }) =>
    $contentAlign === "center" ? "center" : "flex-start"};
  text-align: ${({ $contentAlign }) =>
    $contentAlign === "center" ? "center" : "start"};
  min-height: 42px;
  min-width: 0;
  padding: ${spacing[3]} ${spacing[2]};
  border-bottom: ${({ $isLast }) =>
    $isLast ? "none" : `${borderWidth[1]} solid ${rawColors.stroke[200]}`};
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  overflow: hidden;
`;

export const EmptyBodyRow = styled.div`
  padding: ${spacing[3]} ${spacing[2]};
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
`;
